import { Dialog, DialogActions, DialogContent, DialogTitle, LinearProgress } from '@material-ui/core';
import React from 'react';
import { createUseStyles } from 'src/theming';
import Button from 'src/components/Button';
import { GetHistoryResponse } from './interfaces/History';
import HistoryTable from './components/HistoryTable';

const useStyles = createUseStyles({
  error: {
    color: '#f44336',
    fontSize: '.75rem',
    padding: '0 25px',
  },
  formControl: {
    marginBottom: '16px !important',
  },
});

interface Props {
  history?: GetHistoryResponse;
  error?: string;
  loading: boolean;
  open: boolean;
  page: number;
  limit: number;
  onLimitChange: (limit: number) => void;
  onPageChange: (page: number) => void;
  onClose: () => void;
}

const HistoryDialog: React.FC<Props> = ({
  loading,
  page,
  limit,
  onPageChange,
  onLimitChange,
  error,
  history,
  open,
  onClose,
}) => {
  const classes = useStyles();

  return (
    <Dialog onClose={onClose} scroll='paper' open={open}>
      <DialogTitle>Historique</DialogTitle>

      <DialogContent>
        {history && (
          <HistoryTable
            history={history}
            page={page}
            limit={limit}
            onPageChange={onPageChange}
            onLimitChange={onLimitChange}
          />
        )}
      </DialogContent>

      <DialogActions>
        <Button type='submit' color='primary' onClick={onClose}>
          Fermer
        </Button>
      </DialogActions>

      {error && <p className={classes.error}>{error}</p>}

      {loading && <LinearProgress />}
    </Dialog>
  );
};

export default HistoryDialog;
